<template>
  <v-autocomplete
    class="organization-perimeter-select"
    ref="input"
    :label="label"
    v-model="data"
    :search-input.sync="search"
    v-on="$listeners"
    :items="items"
    :loading="loading"
    item-value="id"
    item-text="name"
    :readonly="readonly"
    :disabled="disabled"
    :clearable="clearable"
    :rules="computedRules"
    hide-details
    hide-no-data
    :solo="solo"
    :multiple="multiple"
    :append-icon="appendIcon"
    :placeholder="placeholder"
    :persistent-placeholder="!!placeholder"
    autocomplete="nope"

  />
</template>

<script>
import OrganizationPerimeterRepository from "@repository/OrganizationPerimeterRepository";

export default {
  name: 'OrganizationPerimeterSelect',
  model: { prop: 'value' },
  props: {
    // v-model: perimeterId (string|null)
    value: { type: [String, null], default: null },
    rules: { type: Array, default: () => [] },
    required: { type: Boolean, default: false },
    disabled: Boolean,
    readonly: Boolean,
    solo: Boolean,
    appendIcon: String,
    placeholder: String,
    multiple: Boolean,
    clearable: { type: Boolean, default: false },
    label: String,
  },
  data() {
    return {
      data: this.value,
      items: [],
      search: null,
      loading: false,
    }
  },
  computed: {
    computedRules() {
      const base = [...this.rules]
      if (this.required) {
        base.unshift(v => !!v || this.$t('required'))
      }
      return base
    }
  },
  watch: {
    value(val) { this.data = val },
    data(val) { this.$emit('input', val) },
    // search() { this.loadItems() }
  },
  mounted() {
    this.loadItems()
  },
  methods: {
    localizedName(nameArr) {
      if (this.localizedString) {
        return this.localizedString(nameArr) || nameArr
      }
      return Array.isArray(nameArr) ? (nameArr[0]?.value || '') : (nameArr || '')
    },
    loadItems() {
      this.loading = true
      OrganizationPerimeterRepository.searchPerimeters('', 0, 1000, 'name', 'asc')
        .then(res => {
          this.items = (res.items || []).map(p => ({ id: p.id, name: this.localizedName(p.name) }))
          this.loading = false
        }).catch(err => {
          this.loading = false
          this.$dialog?.notify?.error(this.$t(err?.response?.data?.message || err?.message))
        })
    },

    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss">
.organization-perimeter-select {}
</style>
